@if (signalRService.chatActive) {
  <div class="container">
    <h3 class="text-center chat_header">Chat</h3>
    <div class="messaging">
      <div class="inbox_msg">
        <div class="mesgs">
          <div class="msg_history">
            @for (msg of messages; track msg) {
              <div>
                @if (msg.type == 'received') {
                  <div class="incoming_msg">
                    <div class="incoming_msg_img"> </div>
                    <div class="received_msg">
                      <div class="received_withd_msg">
                        <span class="">{{msg.message}}</span><br>
                        <span class="">Received: {{msg.date | date:'medium'}}</span><br>
                        <span class="">{{msg.clientuniqueid}}</span>
                        <span class="">{{msg.displayName}}</span>
                      </div>
                    </div>
                  </div>
                }
                @if (msg.type == 'signalr') {
                  <div class="incoming_msg">
                    <div class="incoming_msg_img"> </div>
                    <div class="received_msg">
                      <div class="received_withd_msg">
                        <span class="">{{msg.message}}</span><br>
                        <span class="">SignalR: {{msg.date | date:'medium'}}</span><br>
                        <span class="">{{msg.clientuniqueid}}</span>
                        <span class="">{{msg.displayName}}</span>
                      </div>
                    </div>
                  </div>
                }
                @if (msg.type == 'sent') {
                  <div class="outgoing_msg">
                    <div class="sent_msg">
                      <span class="">{{msg.message}}</span><br>
                      <span class="">Sent: {{msg.date | date:'medium'}}</span><br>
                      <span class="">{{msg.clientuniqueid}}</span>
                      <span class="">{{msg.displayName}}</span>
                    </div>
                  </div>
                }
                <mat-divider></mat-divider>
              </div>
            }
          </div>
          <div class="type_msg">
            <div class="input_msg_write">
              <input type="text" class="write_msg" [value]="txtMessage"
                (input)="txtMessage=$event.target.value" (keydown.enter)="sendMessage()"
                placeholder="Type a message" />
              <button class="msg_send_btn" type="button" (click)="sendMessage()"><i
              class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}